import { Crown, Building2, Store, Ticket, BadgeCheck, Clock, XCircle, Handshake, ShieldCheck, KeyRound } from "lucide-react";

export const BUYER_BADGES = {
  super_stockist: { key: "super_stockist", label: "Super-Stockist", tier: "Tier I", Icon: Crown, from: "#8A4B1F", to: "#E0A45B", glow: "#B87333", blurb: "Highest-volume regional partners holding bulk stock across territories." },
  wholesaler: { key: "wholesaler", label: "Wholesaler", tier: "Tier II", Icon: Building2, from: "#1E4E8C", to: "#5AA0E6", glow: "#4A90D9", blurb: "Distribute bulk material to a network of dealers and retailers." },
  dealer: { key: "dealer", label: "Dealer", tier: "Tier III", Icon: Store, from: "#0F6B54", to: "#37C79E", glow: "#2FB999", blurb: "Serve local markets and project sites with steady demand." },
  booking_agent: { key: "booking_agent", label: "Booking Agent", tier: "Tier IV", Icon: Ticket, from: "#9C2E63", to: "#F07DB2", glow: "#E86AA6", blurb: "Book orders on behalf of clients and earn on committed volume." },
  // ---------------- Level-2 sponsors (sit above dependent Super-Stockists) ----------------
  introducer: { key: "introducer", label: "Introducer", tier: "Level 2 · Sponsor", Icon: Handshake, from: "#4A2C1F", to: "#C7885A", glow: "#B87333", blurb: "Introduce new Super-Stockists into the Vinci network and earn on their throughput." },
  custodian: { key: "custodian", label: "Custodian", tier: "Level 2 · Sponsor", Icon: KeyRound, from: "#2C1F4A", to: "#8A5AC7", glow: "#A78BFA", blurb: "Hold the capital-account and Vinci-Sponsored GST for a dependent Super-Stockist. Small-state Sole-Proprietorship model." },
  guarantor: { key: "guarantor", label: "Guarantor", tier: "Level 2 · Sponsor", Icon: ShieldCheck, from: "#1F3B4A", to: "#5AB0C7", glow: "#4EC0DE", blurb: "Underwrite creditworthiness for a dependent Super-Stockist to unlock higher order ceilings." },
};

export const CATEGORY_INFO_LABEL = {
  super_stockist: "Coverage region & warehousing capacity",
  wholesaler: "Coverage area & expected monthly volume",
  dealer: "Local market served & expected volume",
  booking_agent: "Operating region & client base",
  introducer: "Regions you plan to onboard partners in",
  custodian: "Trade / GST model and the states you will sponsor",
  guarantor: "Credit-underwriting model and typical exposure",
};

// Sub-role → human label for the org-hierarchy tag on Super-Stockists
export const SUB_ROLE_LABEL = {
  independent: "3A · Independent",
  introducer_dependent: "3B · Introducer-Dependent",
  guarantor_dependent: "3C · Guarantor-Dependent",
  custodian_dependent: "3D · Custodian-Dependent",
};

export const SELLER_STATUS_BADGE = {
  pending: { label: "Seller · Pending Review", Icon: Clock, from: "#7A5A12", to: "#D8B23E", glow: "#C79A2E" },
  approved: { label: "Authorised Seller", Icon: BadgeCheck, from: "#0F6B54", to: "#37C79E", glow: "#2FB999" },
  rejected: { label: "Seller · Not Approved", Icon: XCircle, from: "#7A1F1F", to: "#D45B4E", glow: "#C0392B" },
};

export function badgeFor(user) {
  if (!user) return null;
  if (user.account_type === "seller") {
    return SELLER_STATUS_BADGE[user.status] || SELLER_STATUS_BADGE.pending;
  }
  const b = BUYER_BADGES[user.buyer_category];
  return b ? { label: b.label, Icon: b.Icon, from: b.from, to: b.to, glow: b.glow } : null;
}
